<template>
    <transition functional name="slide-down-up-transition" @enter="slideDown" @leave="slideUp">
        <slot />
    </transition>
</template>

<script>
import Velocity from 'velocity-animate';

export default {
    name: 'SlideDownUpTransition',
    methods: {
        slideDown($el, done) {
            Velocity($el, 'stop');
            Velocity($el, 'slideDown', { callback: done });
        },
        slideUp($el, done) {
            Velocity($el, 'stop');
            Velocity($el, 'slideUp', { callback: done });
        },
    },
};
</script>
